import FileSaver from 'file-saver';
import { Parser } from 'json2csv';

export type CsvExportField = { value: string; label?: string };

export function dataToCsvString(
  data: unknown[],
  fields?: CsvExportField[]
): string {
  if (!data.length) {
    return '';
  }

  const js2CSV = new Parser({ fields });
  return js2CSV.parse(data);
}

export function ExportCSV(
  data: unknown[],
  filename: string,
  fields?: CsvExportField[]
): void {
  const downloadName = `${filename}_${new Date().toISOString()}.csv`;

  const parsedText = new Blob([dataToCsvString(data, fields)], {
    type: 'text/plain;charset=utf-8',
  });

  return FileSaver.saveAs(parsedText, downloadName);
}

export function ExportJSON(data: any, filename: string): void {
  const downloadName = `${filename}_${new Date().toISOString()}.json`;

  const parsedText = new Blob([JSON.stringify(data)], {
    type: 'application/json;charset=utf-8',
  });

  return FileSaver.saveAs(parsedText, downloadName);
}
